/// <amd-module name="Test/TestPlansLibrary/LibraryHub/Utils/TestPlansLibraryLocalContextProvider" />
import * as React from "react";
import { ITestPlansLibraryLocalContext, IWorkItemPageOptions } from "Test/TestPlansLibrary/LibraryHub/Redux/TestPlansLibraryContracts";

export const TestPlansLibraryLocalContext = React.createContext<ITestPlansLibraryLocalContext>({} as ITestPlansLibraryLocalContext);

/**
 * testPlansLibraryLocalContextData: The actual data you want to share across components
 */
export let testPlansLibraryLocalContextData: ITestPlansLibraryLocalContext;

export const initializeTestPlansLibraryLocalContext = (currentPivot: string | undefined) => {
    testPlansLibraryLocalContextData = {
        _currentSelectedPivot: currentPivot,
        getCurrentPivot: () => {
            return testPlansLibraryLocalContextData._currentSelectedPivot;
        },
        setCurrentPivot: (val: string) => {
            testPlansLibraryLocalContextData._currentSelectedPivot = val;
        },

        _isPageLoad: true,
        isPageLoad: () => {
            return testPlansLibraryLocalContextData._isPageLoad;
        },
        setPageLoad: (val: boolean) => {
            testPlansLibraryLocalContextData._isPageLoad = val;
        }
    };
};
